module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/regenerator/index.js
// module id = 58
// module chunks = 0